import * as React from "react";
import Avatar from '@material-ui/core/Avatar';
import CasedeskUrl from "../Url/Url";

class Image {

  protected images = {
    loading: require("../../../assets/images/loading.svg"),
    key: require("../../../assets/images/alerts/key.png"),
    info: require("../../../assets/images/alerts/info.png"),
    success: require("../../../assets/images/alerts/success.png"),
    user: require("../../../assets/images/entities/user.svg"),
    company: require("../../../assets/images/entities/company.svg"),
    unit: require("../../../assets/images/entities/unit.svg"),
    property: require("../../../assets/images/entities/property.svg"),
    contract: require("../../../assets/images/entities/contract.svg"),
    event: {
      info: require("../../../assets/images/events/info.png"),
      emailIn: require("../../../assets/images/events/email-in.png"),
      created: require("../../../assets/images/events/created.png"),
      updated: require("../../../assets/images/events/updated.png"),
      removed: require("../../../assets/images/events/removed.png")
    },
    language_image: {
      search_en: require("../../../assets/images/stepper/search_en.png"),
      casadesk_en: require("../../../assets/images/stepper/casadesk_en.png"),
      menu_en: require("../../../assets/images/stepper/menu_en.png"),
      search_nl: require("../../../assets/images/stepper/search_nl.png"),
      casadesk_nl: require("../../../assets/images/stepper/casadesk_nl.png"),
      menu_nl: require("../../../assets/images/stepper/menu_nl.png"),
    },
    coach_company: require("../../../assets/images/coach/company.png"),
    coach_person: require("../../../assets/images/coach/person.png"),
    coach_single_unit: require("../../../assets/images/coach/single_unit.png"),
    coach_multiple_units: require("../../../assets/images/coach/multiple_units.png"),
    coach_complex: require("../../../assets/images/coach/complex.png"),
  };

  protected defaultSize: number = 40;

  public get(property: string, isEvent: boolean = false): string {
    if (isEvent === true) {
      return this.images.event[property];
    }

    return this.images[property];
  }

  //Get image depending on the language
  public getLanguageImage(name: string, languageIso = "") {
    const language = languageIso === "nl-NL" ? "_nl" : "_en"
    if (name) {
      return this.images.language_image[name + language];
    };
  }

  public getImage(property: string, params: any = {}): any {
    return (
      <img
        className={params.hasOwnProperty("size") ? `size-${params.size}` : ""}
        src={this.get(property)}
        style={{
          width: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
          height: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
          backgroundColor: params.hasOwnProperty("backgroundColor") ? params.backgroundColor : "transparent"
        }}
      />
    );
  }

  public getAvatar(property: string, params: any = {}): any {
    return (
      <Avatar
        className={params.hasOwnProperty("size") ? `size-${params.size}` : ""}
        src={this.get(property)}
        style={{
          width: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
          height: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
          backgroundColor: params.hasOwnProperty("backgroundColor") ? params.backgroundColor : "transparent"
        }}
        imgProps={{
          style: {
            objectFit: "contain"
          }
        }}
      />
    );
  }

  public getAvatarAbsolutely(path: string, type: string, params: any = {}): any {
    if (type) {
      if (path.indexOf('http://') === 0 || path.indexOf('https://') === 0){
        return (
          <Avatar
            className={params.hasOwnProperty("size") ? `size-${params.size}` : ""}
            src={CasedeskUrl.getAttachment(path)}
            style={{
              width: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
              height: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
              backgroundColor: params.hasOwnProperty("backgroundColor") ? params.backgroundColor : "transparent"
            }}
            imgProps={{
              style: {
                objectFit: "contain"
              }
            }}
          />
        );
      } else {
        return (
          <div className="icon-wrapper">
            <div className={`icon icon-ic-${type}`} style={{fill: "rgb(117, 117, 117)", color: "rgb(117, 117, 117)", position: "relative" as "relative", top: "2px"}}></div>
          </div>
        );
      }
    } else {
      return (
        <Avatar
          className={params.hasOwnProperty("size") ? `size-${params.size}` : ""}
          src={CasedeskUrl.getAttachment(path)}
          style={{
            width: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
            height: params.hasOwnProperty("size") ? `${params.size}px` : `${this.defaultSize} px`,
            backgroundColor: params.hasOwnProperty("backgroundColor") ? params.backgroundColor : "transparent"
          }}
          imgProps={{
            style: {
              objectFit: "contain"
            }
          }}
        />
      );
    }

  }
}

export default new Image();
